<sd-4-5-1-tooltip
  trigger="hover focus"
  placement="bottom"
  content="{{ 'profile.account.pendingInfo' | transloco }}">
  <div class="sd-chip sd-chip--primary-500">
    {{ 'profile.account.pending' | transloco }}
  </div>
</sd-4-5-1-tooltip>
